// extracted by mini-css-extract-plugin
export default {"wrapper":"GlobalLayout_wrapper__5W7z6"};